import React from 'react'

import styles from "./DotLoader.module.css"

function DotLoader({ color = "#FFFFFF", size = "" }) {
    return (
        <div className={styles.loader}>
            <div className={styles.dot} style={{ backgroundColor: color, width: size, height: size }}></div>
            <div className={styles.dot} style={{ backgroundColor: color, width: size, height: size }}></div>
            <div className={styles.dot} style={{ backgroundColor: color, width: size, height: size }}></div>
        </div>
    )
}

export default DotLoader